import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onSelectedChange", "selected"];
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: not typed yet
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import { callIfPossible } from 'UIComponents/core/Functions';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import Controllable from 'UIComponents/decorators/Controllable';
import { jsx as _jsx } from "react/jsx-runtime";
class UITextToolbarButtonCore extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleClick = evt => {
      const {
        onClick,
        onSelectedChange,
        selected
      } = this.props;
      onSelectedChange(SyntheticEvent(!selected));
      callIfPossible(onClick, evt);
    };
  }
  render() {
    const _this$props = this.props,
      {
        selected
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(SimpleStyledClickable, Object.assign({}, rest, {
      "aria-pressed": selected,
      onClick: this.handleClick
    }));
  }
}
UITextToolbarButtonCore.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onSelectedChange: PropTypes.func,
  selected: PropTypes.bool,
  onClick: PropTypes.func
};
UITextToolbarButtonCore.defaultProps = {
  selected: false
};
UITextToolbarButtonCore.displayName = 'UITextToolbarButtonCore';
const UITextToolbarButton = Controllable(UITextToolbarButtonCore, ['selected']);
UITextToolbarButton.displayName = 'UITextToolbarButton';
export default UITextToolbarButton;